
/**
 * Helper Accumulator for response
 */
export const responseHelper = {
    handleResponse,
    handleError
};

/**
 * This function checks the response; returns data for success and error if otherwise
 * If 401, then logs out user
 * @param response
 * @returns {Promise<never>}
 */
function handleResponse(response) {
    // treat 2xx status as success
    if (Math.floor(response.status/100) !== 2) {
        const error = {response: response};
        return Promise.reject(error);
    }
    return Promise.resolve(response.data);
}

/**
 * This function handles the error response
 * @param errResponse
 */
function handleError(errResponse){
    return {
        "status": errResponse.status,
        "errorMsg": errResponse.statusText,
        "errorDescription": errResponse.data.error_description
    }
}